import React from 'react';
import { useFormContext } from 'react-hook-form';

const StatusRadioGroup = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const salesStatus = watch('salesStatus');

  const statuses = [
    {
      value: 'active',
      label: 'Active',
      className: 'rounded-tl-full rounded-bl-full',
    },
    {
      value: 'inactive',
      label: 'Inactive',
      className: 'border-t-secondary-800 border-b-secondary-800',
    },
    {
      value: 'fraud',
      label: 'Fraud',
      className: 'rounded-tr-full rounded-br-full text-danger-500',
    },
  ];

  return (
    <div className="w-full">
      <div className="w-full max-w-md">
        <label className="block mb-1 font-semibold text-text-hint">
          Status<span className="text-red-500">*</span>
        </label>
        <ul className="grid grid-cols-3 gap-0 mt-1">
          {statuses.map(({ value, label, className }, idx) => (
            <li key={value} className="relative">
              <input
                {...register('salesStatus', {
                  required: 'Sales status is required',
                })}
                type="radio"
                value={value}
                id={value}
                className="sr-only peer"
              />
              <label
                className={`flex justify-center items-center py-2 px-3 bg-white border border-secondary-800 cursor-pointer focus:outline-none hover:bg-gray-50 ${className} ${
                  salesStatus === value
                    ? '!bg-secondary-500 text-white border-secondary-800 font-bold'
                    : ''
                } ${idx === 0 ? 'rounded-l-full' : ''} ${idx === statuses.length - 1 ? 'rounded-r-full' : ''}`}
                htmlFor={value}
              >
                {label}
              </label>
            </li>
          ))}
        </ul>
        {errors.salesStatus && (
          <span className="text-danger-500">{errors.salesStatus.message}</span>
        )}
      </div>
    </div>
  );
};

export default StatusRadioGroup;
